<script>
import { url, goto } from '@sveltech/routify';
import { fileElement, demoImages } from '../utils/stores.js';
import { DEMO_IMAGES } from '../utils/constant.js';

$: imgArr = $demoImages === null || $demoImages.length === 0 ? shuffle(DEMO_IMAGES.map(img => `https://viewer.pxl.ai/images/sample/${img}`)) : JSON.parse($demoImages);

async function upload(event) {
  const element = event.target;
  fileElement.update(() => element);
  $goto(`/view/?type=search`);
}

// ui.js
let imageURL = '';

function enterImageURL() {
  if (imageURL.length === 0) {
    return;
  }
  if (/^[a-f0-9]{64}$/.test(imageURL)) {
    imageURL = `https://img.pxl.ai/${imageURL}`;
  }
  view_demo(imageURL);
}

function view_demo(url) {
    if (window.localStorage.getItem("apikey") == null) {
        alert('No API Key has been configured. Use the configuration dialog to set an API key.')
        return
    }

    var image_url = url;
    $goto(`/view/?image_url=${encodeURIComponent(image_url)}&type=search`);
}

function shuffle(arr) {
  var ranNum, temp, i;
  for (i=arr.length - 1; i>0; i--) {
    ranNum = Math.floor(Math.random() * (i + 1));
    temp = arr[i];
    arr[i] = arr[ranNum];
    arr[ranNum] = temp;
  }
  return arr;
}
</script>

<div class="description">
  <div><b>Artificial Intelligence</b></div>
  <div>Visual <b>Fashion</b> Analysis Platform</div>
</div>
<form class="user-inputs" on:submit|preventDefault={enterImageURL}>
  <input class="shadow-sm" type="text" id="input_url" bind:value={imageURL} placeholder="IMAGE URL or HASH">
  <a class="button-upload" href="javascript:document.getElementById('file').click()"><i class="fas fa-file-upload"></i></a>
  <input type="file" name="file" id="file" on:change={upload} style="display: none;">        
</form>
<div class="demo">
  <div class="label">Demo Images</div>
  <div class="list">
    {#each imgArr.slice(0, 18) as img}
      <div class="grid-item">
        <a href={$url(`/view/?image_url=${encodeURIComponent(`${img}`)}&type=search`)}>
          <img class="thumbnail" src={img} onload="setDirection(this)" decode="async" alt="">
        </a>
      </div>
    {/each}
  </div>
</div>
